// Per-viewer conveniences kept in the browser. Storage may be unavailable, so reads fall back to defaults.
export type Density = 'comfortable' | 'compact';

const DENSITY_KEY = 'uncle-oms:density';

export function loadDensity(fallback: Density): Density {
  try {
    const value = localStorage.getItem(DENSITY_KEY);
    return value === 'compact' || value === 'comfortable' ? value : fallback;
  } catch {
    return fallback;
  }
}

export function saveDensity(value: Density): void {
  try {
    localStorage.setItem(DENSITY_KEY, value);
  } catch {
    // Density then lasts for this session only.
  }
}
